<template>
  <div>
    <div>
      <img :src="frontimg" style="height: 6cm; width: 10cm; margin-top: -10px " />
      <img :src="profileimg" style="height: 133px; width: 106px; margin-left: -368px " />
      <p style="height: 10px; width: 250px; margin-left: 131px; margin-top: -147px; font-size: 16px; color: black; font-family: Nexa Bold; font-weight: bold">{{data.Name}}</p>
      <p style="height: 10px; width: 250px; margin-left: 131px; margin-top: 15px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold">Roll No:</p>
      <p style="height: 10px; width: 150px; margin-left: 216px; margin-top: -23px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">{{data.RollNo}}</p>
      <p style="height: 10px; width: 250px; margin-left: 131px; margin-top: 9px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">Program:</p>
      <p style="height: 10px; width: 150px; margin-left: 216px; margin-top: -22px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">{{data.Program}}</p>
      <p style="height: 10px; width: 250px; margin-left: 131px; margin-top: -3px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">Session:</p>
      <p style="height: 10px; width: 150px; margin-left: 216px; margin-top: -22px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">{{data.Session}}</p>
      <p style="height: 10px; width: 250px; margin-left: 131px; margin-top: -3px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">Department:</p>
      <p style="height: 10px; width: 150px; margin-left: 216px; margin-top: -22px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">{{data.Department}}</p>
    </div>
    <div class="pagebreak">
      <img :src="backimg" style="height: 6cm; width: 10cm; margin-top: 30px; " />
      <p style="height: 10px; width: 270px; margin-left: 40px; margin-top: -192px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">Father's Name:</p>
      <p style="height: 10px; width: 200px; margin-left: 150px; margin-top: -22px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">{{data.FatherName}}</p>
      <p style="height: 10px; width: 270px; margin-left: 40px; margin-top: -3px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">Blood Group:</p>
      <p style="height: 10px; width: 200px; margin-left: 150px; margin-top: -22px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">{{data.BloodGroup}}</p>
      <p style="height: 10px; width: 270px; margin-left: 40px; margin-top: -3px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">CNIC:</p>
      <p style="height: 10px; width: 200px; margin-left: 150px; margin-top: -22px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">{{data.CNIC}}</p>
      <p style="height: 10px; width: 270px; margin-left: 40px; margin-top: -3px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">Address:</p>
      <p style="height: 10px; width: 200px; margin-left: 150px; margin-top: -22px; font-size: 13px; color: black; font-family: Nexa Bold; font-weight: bold ">{{data.Address}}</p>
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        data: {
          Name: '',
          RollNo: '',
          Program: '',
          Session: '',
          Department: '',
          FatherName: '',
          BloodGroup: '',
          CNIC: '',
          Address: '',
        },
        frontimg: '',
        backimg: '',
        profileimg: '',
      }
    },

    created: function () {
    },

    mounted: function () {
      this.loadcardfrontback();
    },

    updated: function () {

    },

    methods: {
      loadcardfrontback() {
        var vm = this;
        axios.post('/api/StudentCardPrintingApi/loadcardfrontback')
          .then(function (response) {
            vm.data = response.data.lst;
            vm.frontimg = response.data.frontimg;
            vm.backimg = response.data.backimg;
            vm.profileimg = response.data.profileimg;
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  })
</script>
<style>
  @media print {
    .pagebreak {
      page-break-before: always;
    }
    /* page-break-after works, as well */
  }
</style>



// WEBPACK FOOTER //
// src/components/cardprinting/printcardfrontback.vue